<template>
  <div>
    <step-title
      title="Links de divulgação"
      description="Veja os links gerados para divulgação do seu produto."
    />
    <div class="w-100">
      <div v-if="product && product.charge_type === 'recurrent'" class="mt-6">
        <action-dispatcher
          action="plan/get"
          :parameters="{ product_id: $route.params.id, limit: 100 }"
        >
          <links-inputs
            v-for="(plan, i) in plans"
            :key="`plan-link-${i}`"
            :product="product"
            :label="plan.name"
            :custom_url="plan.url"
          />
        </action-dispatcher>
      </div>

      <div
        v-else-if="product && product.type_product === 'onsite_event'"
        class="mt-6"
      >
        <div class="text-center my-9" v-if="loading">
          <b-spinner variant="primary" />
        </div>
        <template v-else>
          <action-dispatcher
            action="events/getLots"
            :parameters="{ product_id: $route.params.id, limit: 100 }"
          >
            <links-inputs
              v-for="(link, i) in eventLinks"
              :key="`event-link-${i}`"
              :product="product"
              :label="link.label"
              :custom_url="link.url"
            />
            <div
              v-if="eventLinks.length == 0"
              class="container centralize-row text-center pt-5 my-6 mt-9"
            >
              <div class="row justify-content-center">
                <div class="col-lg-5">
                  <img
                    class="d-block mb-5 mx-auto"
                    src="@/assets/images/home/welcome.png"
                  />
                  <div class="mb-6">
                    <small>
                      Você ainda não tem ingressos cadastrados, clique no botão
                      abaixo e cadastre o primeiro
                    </small>
                  </div>
                  <router-link
                    class="btn btn-primary-500 btn-32 my-5 my-lg-0 text-decoration-none"
                    :to="{
                      name: 'event-new-lot',
                      params: {
                        id: $route.params.id
                      }
                    }"
                  >
                    <div class="d-flex align-items-center">
                      <i class="fa-solid fa-plus mr-3" />
                      <div style="white-space: nowrap">
                        Cadastrar
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </action-dispatcher>
        </template>
      </div>

      <div v-else-if="product">
        <links-inputs :product="product" label="Oferta Principal" />
        <action-dispatcher
          action="offer/get"
          :parameters="{ product_id: $route.params.id, limit: 100 }"
        >
          <h3 class="mt-9 mb-1">Links de ofertas</h3>
          <links-inputs
            v-for="(link, i) in offers"
            :key="`offer-link-${i}`"
            :product="product"
            :label="link.name"
            :custom_url="link.url"
          />
        </action-dispatcher>
      </div>
    </div>
  </div>
</template>

<script>
import LinksInputs from "@/components/product/LinksInputs";
import ProductActionsMixin from "@/mixins/productActions.js";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin],
  components: { LinksInputs },
  data() {
    let offer = "";
    if (this.$route.query.offer && this.$route.query.offer !== "padrao") {
      offer = this.$route.query.offer;
    }
    let plan = "";
    if (this.$route.query.plan && this.$route.query.plan !== "padrao") {
      plan = this.$route.query.plan;
    }
    return {
      loading: false,
      filters: {
        plan,
        offer,
        group: ""
      }
    };
  },
  computed: {
    ...mapState("membersGroups", ["groupsFilter"]),
    ...mapState("product", ["product"]),
    ...mapState("plan", ["plans"]),
    ...mapState("offer", ["offers"]),
    ...mapState("events", ["lots"]),
    plan() {
      return this.plans.find(plan => plan.id === this.filters.plan);
    },
    offer() {
      return this.offers.find(offer => offer.id === this.filters.offer);
    },
    group() {
      return this.groupsFilter.find(group => group.id === this.filters.group);
    },
    eventLinks() {
      return this.lots.map(t => ({ ...t, label: t.name }));
    }
  },
  watch: {
    "filters.offer"() {
      this.filters.group = null;
    },
    "filters.plan"() {
      this.filters.group = null;
    }
  }
};
</script>
